import React from "react";
import PropTypes from 'prop-types';

import { Separator } from "../Headers/Separator";
import Carousel from 'react-multi-carousel';
import { CardEventosProximos } from "./CardEventosProximos";
import { differenceInDays, format } from "date-fns";
// import { es } from 'date-fns/locale/es'
// import { Timestamp } from 'firebase/firestore/lite';
import 'react-multi-carousel/lib/styles.css';
import '../../styles/EventosProximos.css'



const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };




export const EventosProximos = (props) =>{
    const eventos = (props.events) ? props.events.filter( (event) => new Date(event.startDate.seconds*1000) >= new Date()  ) : [] ;
    if ( eventos.length <= 0 )
    {
        return null;
    }
    return(
        <section id="EventosProximos" className="section">
            <Separator name ='Eventos Proximos'/>

            <div className="container">
                <Carousel 
                responsive={responsive}
                showDots={true}
                containerClass="carousel-container"
                > 
                    { 
                        eventos.map( (elem, idx) =>{
                            let dateStr = "";
                            if ( !elem.startDate )
                            {
                                return null;
                            }
                            const startDate = new Date(elem.startDate.seconds*1000);
                            const endDate = new Date(elem.endDate.seconds*1000);
                            const difference = differenceInDays(endDate, startDate);
                            if ( difference >= 28 )
                            {
                                dateStr = new Intl.DateTimeFormat("es-MX", {"month": "long"}).format(startDate) + " " + startDate.getFullYear();
                                dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
                            }
                            else
                            {
                                dateStr = format(startDate, 'dd/MM/yy') + ' - ' + format(endDate, 'dd/MM/yy');
                            }
                            return(
                                <CardEventosProximos idx={idx} key={elem}  name ={elem.title} foto={elem.url_image} uni={elem.content} linea={dateStr}></CardEventosProximos>
                            )
                        })
                    }
                    </Carousel>
            </div>
        </section>
    )
}

EventosProximos.propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        url_image: PropTypes.string,
        content: PropTypes.string,
        startDate: PropTypes.shape({
            seconds: PropTypes.number.isRequired,
        }).isRequired,
        endDate: PropTypes.shape({
            seconds: PropTypes.number.isRequired,
        }).isRequired,
    })),
};